/**
 * Toolkit JavaScript
 */

'use strict';

	// plugins
	var $ = require('script!./plugins/jquery.min');
	var jQuery = $;
	

	// modules
	require('./modules/globals');
	require('./partial/loader');


// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/toolkit.js